<template lang="html">
    <div id="association"
         v-loading.fullscreen.lock.body="loading"
         element-loading-text="拼命加载中"
         element-loading-spinner="el-icon-loading"
         element-loading-background="rgba(0, 0, 0, 0.8)"
    >
        <tutorBar :tags="tags" :title="title"
                  :association = "form.coachee_name"
                  :associationName = "form.coach_name"
                  :associationDateStr = "form.dateStr"
                  :textIndeed ="form.textIndeed"
                  :btnSuccess = "onoffSuccess"
                  :btnAgree="onoffAgreed"
                  :btnRefuse="onoffRefused"
                  :btnSubmit="onoffSubmit"
                  :btnSave="onoffSave"
                  :btnBack="true"
                  :btnDelete="deleteOnOff"
                  @btnDeleteClick="btnDeleteClick"
                  @btnAgreeClick="btnAgreeClick" @btnSuccess="btnSuccess" @btnRefuseClick="btnRefuseClick"
                  @btnSubmitClick="btnSubmitClick"
                  @btnSaveClick="inputBtnSaveClick"  @btnBackClick="handleBackClick"/>
<!--        左侧-->
        <div style="width: 70%;margin-top:10px;float: left;">
            <el-form label-width="120px" :model="form" hide-required-asterisk
                     :rules="rules" ref="formlist" >
                <el-row>
                    <el-col v-if="onofTerritory==true&&this.status=='NEW'">
                        <el-form-item  label="辖区" class="dropDetails_star" prop="territory_id" :rules="[{required:true,message:'辖区不能为空'}]">
                            <el-select v-model="form.territory_id" placeholder="请选择辖区" :disabled="selectTerritory" @change="changeTerritory"
                                       style="width: 60%;"
                                       clearable>
                                <el-option
                                        v-for="item in optionTerritoryList"
                                        :key="item.territory_id"
                                        :label="item.territory_name"
                                        :value="item.territory_id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col v-if="onofTerritory==true && this.status=='INFO'">
                        <el-form-item  label="辖区" class="dropDetails_star" prop="territory_id" :rules="[{required:true,message:'辖区不能为空'}]">
                            <el-select v-model="form.territory_id" placeholder="请选择辖区" :disabled="selectTerritory"
                                       style="width: 60%;"
                                       clearable>
                                <el-option
                                        v-for="item in optionTerritoryList"
                                        :key="item.territory_id"
                                        :label="item.territory_name"
                                        :value="item.territory_id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col v-if="onoffRecord === false">
                        <el-form-item label="协访日期" class="dropDetails_star" prop="date"  >
                                <el-date-picker :disabled="onoffFormCoach"
                                        v-model="dateRange"
                                        type="datetimerange"
                                        style="width: 60%;"
                                        range-separator="至"
                                        :picker-options="pickerOptions0"
                                        format="yyyy-M-d HH:mm"
                                        value-format="yyyy-MM-dd HH:mm"
                                        start-placeholder="开始日期"
                                        @change="chooseTimeRangeTow"
                                        end-placeholder="结束日期">
                                </el-date-picker>
                        </el-form-item>
                    </el-col>
<!--                    <el-col v-if="onoffRecord === false">-->
<!--                        <el-form-item label="协访日期" class="dropDetails_star" prop="date">-->
<!--                            <div style="width: 60%;">-->
<!--                                <el-date-picker-->
<!--                                    v-model="form.start_time"-->
<!--                                    type="datetime"-->
<!--                                    placeholder="选择日期"-->
<!--                                    format="yyyy-MM-dd HH:mm"-->
<!--                                    value-format="yyyy-MM-dd HH:mm"-->
<!--                                    :picker-options="pickerOptions0"-->
<!--                                    style="width: 49%"-->
<!--                                    @change="chooseTimeRange0"-->
<!--                                    >-->
<!--                            </el-date-picker><span style="display: inline-block;width: 2%"></span><el-date-picker-->
<!--                                    v-model="form.end_time"-->
<!--                                    type="datetime"-->
<!--                                    placeholder="选择日期"-->
<!--                                    format="yyyy-MM-dd HH:mm"-->
<!--                                    value-format="yyyy-MM-dd HH:mm"-->
<!--                                    :picker-options="pickerOptions1"-->
<!--                                    style="width: 49%"-->
<!--                                    @change="chooseTimeRange1"-->
<!--                                    >-->
<!--                            </el-date-picker>-->
<!--                            </div>-->
<!--                        </el-form-item>-->
<!--                    </el-col>-->
                    <el-col v-if="onoffRecord === true">
                        <el-form-item label="协访日期" class="dropDetails_star" prop="date"  >
                            <el-date-picker :disabled="onoffFormCoach"
                                    v-model="dateRange"
                                    type="datetimerange"
                                    style="width: 60%;"
                                    range-separator="至"
                                    format="yyyy-M-d HH:mm"
                                    value-format="yyyy-MM-dd HH:mm"
                                    start-placeholder="开始日期"
                                    :picker-options="pickerOptions2"
                                    @change="chooseTimeRangeOne"
                                    end-placeholder="结束日期">
                            </el-date-picker>
                        </el-form-item>
                    </el-col>
<!--                    <el-col v-if="onoffRecord === true">-->
<!--                        <el-form-item label="协访日期" class="dropDetails_star" prop="date">-->
<!--                            <div style="width: 60%;">-->
<!--                            <el-date-picker-->
<!--                                v-model="form.start_time"-->
<!--                                type="datetime"-->
<!--                                placeholder="选择日期"-->
<!--                                format="yyyy-MM-dd HH:mm"-->
<!--                                value-format="yyyy-MM-dd HH:mm"-->
<!--                                :picker-options="pickerOptions2"-->
<!--                                style="width: 49%"-->
<!--                                @change="chooseTimeRange2"-->
<!--                                >-->
<!--                        </el-date-picker><span style="display: inline-block;width: 2%"></span><el-date-picker-->
<!--                                v-model="form.end_time"-->
<!--                                type="datetime"-->
<!--                                placeholder="选择日期"-->
<!--                                format="yyyy-MM-dd HH:mm"-->
<!--                                value-format="yyyy-MM-dd HH:mm"-->
<!--                                :picker-options="pickerOptions3"-->
<!--                                style="width: 49%"-->
<!--                                @change="chooseTimeRange3"-->
<!--                                >-->
<!--                        </el-date-picker>-->

<!--                         </div>-->
<!--                        </el-form-item>-->
<!--                    </el-col>-->
                    <el-col>
                        <el-form-item class="dropDetails_star" label="协访人" prop="coach_id" :rules="[{required:true,message:'协访人不能为空'}]">
                            <el-select :disabled="onoffCoach||onoffFormCoach" v-model="form.coach_id" placeholder="请选择协访人" style="width: 60%;" clearable>
                                <el-option
                                        v-for="item in optionVisitorList"
                                        :key="item.owner_id"
                                        :label="item.owner_name"
                                        :value="item.owner_id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col>
                        <el-form-item class="dropDetails_star" label="被协访人" prop="coachee_id" :rules="[{required:true,message:'被协访人不能为空'}]">
                            <el-select :disabled="onoffCoachee||onoffFormCoach" v-model="form.coachee_id" placeholder="请选择被协访人"
                                       style="width: 60%;"
                                       @focus="clickCoa" @change.stop="changeCoachee"  clearable>
                                <el-option
                                        v-for="item in optionUnVisitorList"
                                        :key="item.owner_id"
                                        :label="item.owner_name"
                                        :value="item.owner_id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col>
                        <el-form-item class="dropDetails_star" label="协访类型" prop="coaching_type" :rules="[{required:true,message:'协访类型不能为空'}]">
                            <el-select v-model="form.coaching_type" placeholder="" style="width: 60%;"  :disabled="onoffFormCoach" clearable>
                                <el-option
                                        v-for="item in optionCoachingTypeList"
                                        :key="item.key"
                                        :label="item.value1"
                                        :value="item.key">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
<!--                    <el-col v-if="onoffAccordingRecord">-->
<!--                        <el-form-item label="计划/记录">-->
<!--                            <el-switch-->
<!--                                    :disabled="onoffSwitch"-->
<!--                                    @change="recordSwitch"-->
<!--                                    v-model="onoffRecord"-->
<!--                                    active-color="#13ce66"-->
<!--                                    inactive-color="#ff4949">-->
<!--                            </el-switch>-->
<!--                        </el-form-item>-->
<!--                    </el-col>-->
                </el-row>
            </el-form>
            <el-row>
            <el-col>
                <el-col>
                    <p v-if="onoffAssistLength" style="color: #B8B8B8;font-size: 16px;margin: 15px 0;">协访客户</p>
                </el-col>
                <el-col>
                    <el-button v-if="onoffAssist" type="success" size="small" @click="addAssist"
                               style="float: left;background-color: #4ec880;color: white;border: 1px solid #4ec880;margin-bottom: 4px;font-size:13px">
                        <i :class="['iconfont', 'el-icon-plus']" style="color: #ffffff"></i>
                        添加
                    </el-button>
                </el-col>
                <el-col v-for="(item,i) in form.clientInfo_array" style="border: 1px solid #979797;width: 425px;
                margin:10px 0;">
                    <p
                            style="font-size: 16px;color: #4D586D;margin: 20px 20px 10px 20px;">
                        {{item.infoObj | filterCustomerName }}
                        <span style="color: #ED3B3F;font-size: 12px;float: right"
                              v-if="onoffAssist"
                              @click="reMoveClient(item,i)">移除
                                </span></p>
                    <p style="font-size: 14px;color: #B0B5B9;padding:0 20px;margin-top:0;">{{item.infoObj
                        .address}}</p>
                    <p
                            style="font-size: 14px; color: #7ED321;margin-left: 20px;">
                        <span style="display: inline-block;width: 60px">{{item.infoObj | filterCustomerGrade}}</span>

                        <span style="color:#3b99f7;margin-left: 30px;">目标客户{{item.infoObj.target_num}}人 | 当月覆盖{{item.infoObj
                                .cover_num}}人</span></p>
                    <p style="padding-left: 20px;border-top: 1px solid #979797;font-size: 14px;
                            color: #B0B5B9;line-height: 1;padding-top:15px;margin: 0;margin-bottom: 15px;">
                        <span style="display: inline-block;width: 100px">{{item.infoObj.date | filterDate}}</span>

                        <span :style="{'color':item.infoObj.checkin_time ? '#f5a623' : '#ED3B3F'}" style="
                                margin:0px 30px;">
                                    {{item.infoObj.checkin_time | filterCheck('in')}}</span>
                        <span :style="{'color':item.infoObj.checkin_time ? '#f5a623' : '#ED3B3F' }" >{{item.infoObj.checkout_time | filterCheck('no')}}</span>
                    </p>
                </el-col>
                <el-col>
                    <p v-if="this.onoffAssessLength"
                       style="color: #B8B8B8;font-size: 16px;margin: 15px 0;">协访评估
                    </p>
                </el-col>
                <el-col>
                    <el-button v-if="onoffAssess" @click="addAssessBool" @click.stop="" type="success"
                               size="small"
                               style="float: left;background-color: #4ec880;color: white;border: 1px solid #4ec880;margin-bottom: 4px;font-size: 13px">
                        <i :class="['iconfont', 'el-icon-plus']" style="color: #ffffff"></i>
                        添加
                    </el-button>
                </el-col>
                <el-col v-for="(item,i) in form.formInfo_array"
                        style="border: 1px solid #979797;width: 60%;margin: 10px 0;">
                    <p style="font-size: 20px;color: #4D586D;margin: 20px 14px;">{{item.from_name}}
                        <span v-if="filterDetails(item)" style="display: inline-block;background: #FF9901;
                                color: #fff;font-size: 14px;padding: 5px 10px;margin-left:20px;border-radius: 10%;vertical-align: center;">{{item.final_score}}分</span>
                        <span v-if="item.evaluation == '差'" style="display: inline-block;padding: 3px 8px;margin-left:20px;border-radius: 10%;border: 1px solid #c22b26;
                                color: #c22b26;font-size: 14px;vertical-align: center;">{{item.evaluation}}</span>
                        <span v-if="item.evaluation == '良好'" style="display: inline-block;padding: 3px 8px;margin-left:20px;border-radius: 10%;border: 1px solid #f4912f;
                                color: #f4912f;font-size: 14px;vertical-align: center;">{{item.evaluation}}</span>
                        <span v-if="item.evaluation == '优秀'" style="display: inline-block;padding: 3px 8px;margin-left:20px;border-radius: 10%;border: 1px solid #6cc584;
                                color: #6cc584;font-size: 14px;vertical-align: center;">{{item.evaluation}}</span>

                        <span @click="detailsBoolInfo(item)" v-if="filterDetails(item)"
                              style="cursor: pointer;color: #FF9901;font-size:
                                14px;float: right;">详情</span>
                    </p>
                    <p v-for="(obj,j) in item.category_array" v-if="filterDetails(item)"
                       style="font-size: 15px; color: #4D4D4D;
                            margin: 15px 0px 15px 15px;">{{obj.name}} ( {{obj.items}} ) 个项目
                        <span style="float: right;width: 50%;text-align: right">
                                    <span
                                            style="background: #86909A;border-radius:50%;display: inline-block;font-size: 12px;
                                    width:20px;height: 20px;margin-right: 1%;text-align: center;line-height: 20px;color:#fff;">
                                        {{obj.incompleted_items}}</span>
                                    <span style="background: #6BC235;border-radius:50%;display: inline-block;width: 20px;height: 20px;
                                    text-align: center;margin-right: 1%;line-height: 20px;color:#fff;font-size: 12px">{{obj.passed_items}}</span>
                                    <span style="background: #D0011B;border-radius:50%;display: inline-block;width: 20px;height: 20px;
                                    text-align: center;margin-right: 1%;line-height: 20px;color:#fff;font-size: 12px">{{obj.failed_items}}</span>
                                    <span
                                            style="border-left: 1px solid #b0b5b9;
                                            margin-left:3%;
                                            padding-left: 4%;
                                            display: inline-block;width: 50px;text-align: left">{{obj.subtotal_score
                                        }}分</span>
                                </span>
                    </p>
                </el-col>
            </el-col>
        </el-row>
        </div>
        <div  v-if="onoffPlan"
             style="width: 27%;float: left;border:1px solid #DEDEDE;box-sizing: border-box;background: #F4F6F8;margin-top:10px;margin-left:3%;border-radius: 8px;min-height: calc(100% - 160px);">
            <el-row>
                <el-button @click="openSavePlanModel"
                           v-if="writePenBtnOnOff"
                           :class="['iconfont', 'el-icon-edit-outline',]" size="small"
                           type="primary"
                           style="float:right;height: 32px;padding: 8px 10px;
                           margin-top: 10px;margin-right: 10px;">
                    <i></i>写一笔</el-button>
            </el-row>

            <el-row style="overflow: auto">
                <el-col v-for="(item,j) in form.ps_Array" style="padding: 5%;">
                    <div style="width: 30px;height: 30px;float: left;overflow: hidden;border-radius: 100%;
                            position: relative">
                        <img v-if="item.src" :src="item.src"
                             width="100%"
                             alt="" style=" position: absolute;
                                        top:50%;
                                        left:50%;
                                        transform: translate(-50%,-50%);">
                    </div>
                    <div style="float:right;width: calc(100% - 50px)">
                        <p style="margin-top:0%;margin-bottom:0%;color: #4D586D;font-size: 12px">{{item.last_name}}</p>
                        <p :class="['iconfont','el-icon-time',]"
                           style="color: #87909A;margin-top:5px;margin-bottom:0%;font-size: 12px;"><i></i>{{
                            item.timestamp | componentFliter}}</p>
                        <p style="white-space:normal;
                        margin-top:10px;margin-bottom:5%;
                        word-break:break-all;overflow:hidden;
                        width:90%;color: #4A4A4A;font-size: 13px;line-height: 20px">{{item.contents.comments}}</p>
                    </div>
                </el-col>

            </el-row>
        </div>
<!--        右侧留言-->
<!--        <div  v-if="onoffPlan"-->
<!--                style="width: 27%;float: right;border:1px solid #DEDEDE;background: #F4F6F8;margin-top:10px;margin-left:2%;border-radius: 1%;-->
<!--        min-height: calc(100% - 120px);">-->
<!--            <el-row>-->
<!--                <el-button @click="openSavePlanModel" v-if="writePenBtnOnOff"-->
<!--                           :class="['iconfont', 'el-icon-edit-outline',]" size="small"-->
<!--                           type="primary"-->
<!--                           style="float:right;-->
<!--                           margin-top: 10px;margin-right: 10px;">-->
<!--                    <i></i>写一笔</el-button>-->
<!--            </el-row>-->
<!--            <el-row style="overflow: auto">-->
<!--                <el-col v-for="item,j in form.ps_Array" style="padding: 5%;">-->
<!--                    <div style="width: 50px;height: 50px;float: left;overflow: hidden;border-radius: 50px;position: relative">-->
<!--                        <img v-if="item.src" :src="item.src" alt=""-->
<!--                             width="100%"-->
<!--                             style=" position: absolute;-->
<!--                                        top:50%;-->
<!--                                        left:50%;-->
<!--                                        transform: translate(-50%,-50%);">-->

<!--                    </div>-->
<!--                    <div style="float: right;width: calc(100% - 60px)">-->
<!--                        <p style="margin-top:0%;margin-bottom:0%;color: #4D586D;font-size: 12px">{{item.last_name}}</p>-->
<!--                        <p :class="['iconfont','el-icon-time',]"-->
<!--                           style="color: #87909A;margin-top:10px;margin-bottom:0%;font-size: 12px"><i></i>{{-->
<!--                            item.timestamp | componentFliter}}</p>-->
<!--                        <p style="white-space:normal;-->
<!--                        margin-top:10px;margin-bottom:5%;-->
<!--                        word-break:break-all;overflow:hidden;-->
<!--                        width:90%;color: #4A4A4A;font-size: 16px">{{item.contents.comments}}</p>-->
<!--                    </div>-->
<!--                </el-col>-->

<!--            </el-row>-->
<!--        </div>-->
<!--        添加协访客户-->
        <el-dialog
                :visible.sync="assistBool"
                width="700px"
                :show-close="false"
                style="vertical-align: center;: #FFF9F3;">
            <div>
                <el-row style="border-bottom: 2px dotted #e7eaec;padding-bottom: 10px;">
                    <el-col :span="12">
                        <div style="color: #3998F7;font-size: 22px;padding-top: 5px">添加协访客户
                        </div>
                    </el-col>
                    <el-col :span="12">
                        <div align="right">
                            <el-button type="primary" size="small" @click.native="addAssistBool">
                                保存
                            </el-button>
                            <el-button type="danger" size="small" @click.native="closeAssistBool">
                                关闭
                            </el-button>
                        </div>
                    </el-col>
                </el-row>
                <div id="assist" style="margin-top: 20px;">
                    <el-tabs v-model="activeName" type="card" style="margin: auto">
                        <el-tab-pane label="医疗机构" name="医疗机构" style="height: 400px;overflow: auto" v-if="clientObj.showInstitution">
                            <el-col v-for="(item,i) in addVisitForm.institutionsArray" :span="22" :push="1"
                                    style="border: 1px solid #979797;margin-bottom: 10px;height: 90px"
                                    @click.native="checkVisitInfoIns(item)">
                                <p style="margin: 10px 10px;font-weight: bold;font-size: 15px;">{{item.institution_name}}</p>
                                <p style="margin: 0px 10px;margin-bottom: 34px;">
                                    <el-col :span="22" style="font-size: 13px; color: #B0B5B9;border: 1px solid transparent">
                                        {{item.address}}
                                    </el-col>
                                    <el-col :span="2">
                                            <img v-if="item.onoff ? true : false" style="width: 20px;height: 20px;"
                                                 src="../../../assets/images/speakers.png"/>
                                            <img v-else :src="check" alt="" style="width: 20px;height: 20px;">
                                    </el-col>
                                </p>
                                <p style="margin:15px 10px;color: #7ED321;">
                                    <span style="display: inline-block;width: 60px">{{item.institution_grade}}</span>
                                    <span>|</span>
                                    <span style="margin-left: 4px">医务人员总数：
                                        {{item.hcps}}
                                        人</span>
                                    <span style="color: #3b99f7;float: right;margin-right: 80px;">目标客户
                                        {{item.target_num}}
                                        人</span>
                                </p>
                            </el-col>
                        </el-tab-pane>
                        <el-tab-pane label="零售终端" name="零售终端" style="height: 400px;overflow: auto" v-if="clientObj.showStore">
                            <el-col v-for="(item,i) in addVisitForm.retailstoreArray" :span="22" :push="1"
                                    style="border: 1px solid #979797;margin-bottom: 10px;height: 90px"
                                    @click.native="checkVisitInfoStore(item)"
                                    >
                                <p style="margin: 10px 10px;font-weight: bold;font-size: 15px;">{{item.store_name}}</p>
                                <p style="margin: 0px 10px;margin-bottom: 34px;">
                                    <el-col :span="22" style="font-size: 13px; color: #B0B5B9;border: 1px solid transparent">
                                        {{item.address}}
                                    </el-col>
                                    <el-col :span="2">
                                        <img v-if="item.onoff ? true : false" style="width: 20px;height: 20px;"
                                             src="../../../assets/images/speakers.png"/>
                                        <img v-else :src="check" alt="" style="width: 20px;height: 20px;">
                                    </el-col>
                                </p>
                                <p style="margin:15px 10px;color: #7ED321;">
                                    <span>{{item.retailstore_grade}}</span>
                                    <span style="color: #3b99f7;float: right;margin-right: 80px;">店员
                                        {{item.clerk_num}}
                                        人  |   本月巡店
                                        {{item.inspection_num}}
                                        次</span>
                                </p>
                            </el-col>
                        </el-tab-pane>
                        <el-tab-pane label="分销客户" name="分销客户" style="height: 400px;overflow: auto" v-if="clientObj.showDistributor">
                            <el-col v-for="(item,i) in addVisitForm.distributorArray" :span="22" :push="1"
                                    style="border: 1px solid #979797;margin-bottom: 10px;height:90px"
                                    @click.native="checkVisitInfoDis(item)"
                            >
                                <p style="margin: 10px 10px;font-weight: bold;font-size: 15px;">{{item.distributor_name}}</p>
                                <p style="margin: 0px 10px;margin-bottom: 34px;">
                                    <el-col :span="22" style="font-size: 13px; color: #B0B5B9;border: 1px solid transparent">
                                        {{item.address}}
                                    </el-col>
                                    <el-col :span="2">
                                        <img v-if="item.onoff ? true : false" style="width: 20px;height: 20px;"
                                             src="../../../assets/images/speakers.png"/>
                                        <img v-else :src="check" alt="" style="width: 20px;height: 20px;">
                                    </el-col>
                                </p>
                                <p style="margin:15px 10px;color: #7ED321;">
                                    <span>{{item.distributor_grade}}</span>
                                    <span style="color: #3b99f7;float: right;margin-right: 80px;">
                                    本月拜访
                                        {{item.inspection_num}}
                                        次</span>
                                </p>
                            </el-col>
                        </el-tab-pane>
                    </el-tabs>
                    <el-form ref="formlist1"  label-width="20%" style="margin-top:50px;">
                        <el-row>
                            <el-col :span="3">
                                <span style="font-size: 16px;font-weight: bold">邀请客户</span>
                            </el-col>
                            <el-col :span="21">
                                    <el-card class="box-card" style="box-shadow: none">
                                      <span  v-for="(item,i) in form.clientInfo_array"
                                             style="display: inline-block;
                                              background: #FF9901;
                                              color: white;padding: 2px 6px;
                                              margin-top: 6px;
                                              margin-right: 10px;
                                              border-radius: 6px;
                                              line-height: 25px;font-size: 12px">
                                          {{item.infoObj | filterCustomerName }}
                                          </span>
                                    </el-card>

                            </el-col>
                        </el-row>

                    </el-form>
                </div>
            </div>

        </el-dialog>
<!--        添加协访评估-->
        <el-dialog
                :visible.sync="assessBool"
                width="70%"
                :show-close="false"
                style="vertical-align: center;: #FFF9F3">
            <div>
                <el-row style="border-bottom: 2px dotted #e7eaec;padding-bottom: 10px;">
                    <el-col :span="12">
                        <div style="color: #3998F7;font-size: 22px;padding-top: 5px">添加协访评估
                        </div>
                    </el-col>
                    <el-col :span="12">
                        <div align="right">
                            <el-button type="primary" size="small" @click.native="addAssessBoolModel">
                                保存
                            </el-button>
                            <el-button type="danger" size="small" @click.native="closeAssessBool">
                                关闭
                            </el-button>
                        </div>
                    </el-col>
                </el-row>
            </div>
            <el-row style="margin-top: 20px;">
                <el-col :span="9" style="margin-right: 20px;">
                    <el-col :span="24" style="border: 1px solid #979797;margin-bottom: 10px;"
                            @click.native="getClassProject(item)"
                            v-for="(item,i) in addCoachingFromList.coachingFromArray">
                        <p style="margin: 10px 10px;font-weight: bold;font-size: 15px;">{{item.title}}</p>
                        <p style="margin: 0px 10px;margin-bottom: 34px;">
                            <el-col :span="20" style="font-size: 13px; color: #B0B5B9;border: 1px solid transparent">
                                {{item.comments}}
                            </el-col>
                            <el-col :span="2">
                                <span  style="display: inline-block;width: 20px;height: 20px;border: 1px solid #FD9801;border-radius: 50%;margin-top:-4px;">
                                    <img v-if="item.onoff" style="width: 20px;height: 20px;"
                                         src="../../../assets/images/speakers.png"/>
                                </span>
                            </el-col>
                            <el-col :span="2">
                                <span style="float: right;margin-top:-2px;">
                                    >
                                </span>
                            </el-col>
                        </p>
                        <p style="margin:15px 10px;color: #7ED321;">
                            <span>{{item.categorylength}}个类别</span>
                            <span></span>
                            <span>共{{item.projectlength}}个项目</span>
                        </p>
                    </el-col>
                </el-col>
                <el-col :span="14">
                    <el-row style="padding-left: 20px;border-left: 1px solid #979797;max-height: 700px;overflow: auto">
                        <el-col v-for="(item,i) in addCoachingFromList.smallFromArray">
                            <p>{{item.name}}（{{item.items}}个项目）</p>
                            <el-col style="border: 1px solid #979797;margin-bottom: 10px;height: 100px" v-for="(obj,j) in
                            item.item_array">
                                <el-col :span="16">
                                    <p style="margin: 10px 20px;font-size: 14px;color: #F5A623;">{{j+1+"、"}}
                                        {{obj.item_title}}</p>
                                    <P style="margin: 5px 20px;font-size: 12px;color: #ADB3B8;">要求：</P>
                                    <p style="margin: 0px 20px;margin-bottom: 10px;font-size: 12px;color: #ADB3B8;"></p>
                                </el-col>
    <!--                            右侧通过判断显示不同类型-->
                                <el-col  v-if="obj.item_type === 'TRUE-FALSE'" :span="8"
                                         style="background:rgba(74,144,226,0.1);height: 100%">
                                    <p style="width: 100%;text-align: center">
                                        <span style="display: inline-block;width: 26px;height: 26px;border:1px solid #6BC235;border-radius: 50%;">
                                            <img src="../../../assets/images/radio_qualified.png"/>
                                        </span>
                                        <span style="padding: 0px 10px;">
                                            <img src="../../../assets/images/line.png"/>
                                        </span>
                                        <span style="display: inline-block;width: 26px;height: 26px;border:1px solid #D0011B;border-radius: 50%;">
                                            <img  src="../../../assets/images/radio_unqualified.png"/>
                                        </span>
                                    </p>
                                    <p style="font-size: 16px;color: #4A4A4A;text-align:center;margin-top:15px;margin-bottom: 20px;">
                                        <span>合格</span>
                                        <span>/</span>
                                        <span>不合格</span>
                                    </p>
                                </el-col>
                                <el-col v-else-if="obj.item_type === 'SCORE'" :span="8" style="background:rgba(74,144,226,0.1);height: 100%">
                                    <p style="height: 100%;text-align: center">
                                        <span style="">
                                            <span :class="{scoreActive: obj.pass_score =='1'}"
                                                  style="cursor: pointer;display: inline-block;width: 15px;height: 15px;border: 1px solid #979797;border-radius: 50%;font-size: 13px;color: #979797;text-align: center;line-height: 15px;">1</span>
                                            <span :class="{scoreActive: obj.pass_score =='2'}" style="cursor: pointer;display: inline-block;width: 15px;height: 15px;border: 1px solid #979797;border-radius: 50%;font-size: 13px;color: #979797;text-align: center;line-height: 15px;">2</span>
                                            <span>
                                                ···
                                            </span>
                                            <span  :class="{scoreActive: true}" style="cursor: pointer;display:inline-block;width: 15px;height: 15px;border: 1px solid #979797;border-radius: 50%;font-size: 13px;color: #979797;text-align: center;line-height: 15px;">8</span>
                                            <span  :class="{scoreActive: obj.pass_score =='9'}" style="cursor: pointer;display: inline-block;width: 15px;height: 15px;border: 1px solid #979797;border-radius: 50%;font-size: 13px;color: #979797;text-align: center;line-height: 15px;">9</span>
                                            <span  :class="{scoreActive: obj.pass_score =='10'}" style="cursor: pointer;display: inline-block;width: 15px;height: 15px;border: 1px solid #979797;border-radius: 50%;font-size: 13px;color: #979797;text-align: center;line-height: 15px;">10</span>
                                        </span>
                                        <span style="display: block;margin-top: 20px">评分 （1-10分）</span>
                                    </p>

                                </el-col>
                                <el-col v-else-if="obj.item_type === 'SCORE5'" :span="8" style="background:rgba(74,144,226,0.1);height: 100%">
                                    <p style="height: 100%;text-align: center">
                                        <span style="">
                                            <span :class="{scoreActive: obj.pass_score =='1'}"
                                                  style="cursor: pointer;display: inline-block;width: 15px;height: 15px;border: 1px solid #979797;border-radius: 50%;font-size: 13px;color: #979797;text-align: center;line-height: 15px;">1</span>
                                            <span :class="{scoreActive: obj.pass_score =='2'}" style="cursor: pointer;display: inline-block;width: 15px;height: 15px;border: 1px solid #979797;border-radius: 50%;font-size: 13px;color: #979797;text-align: center;line-height: 15px;">2</span>

                                            <span  :class="{scoreActive: obj.pass_score =='3'}" style="cursor: pointer;display: inline-block;width: 15px;height: 15px;border: 1px solid #979797;border-radius: 50%;font-size: 13px;color: #979797;text-align: center;line-height: 15px;">3</span>
                                            <span  :class="{scoreActive: true}" style="cursor: pointer;display:inline-block;width: 15px;height: 15px;border: 1px solid #979797;border-radius: 50%;font-size: 13px;color: #979797;text-align: center;line-height: 15px;">4</span>
                                            <span  :class="{scoreActive: obj.pass_score =='3'}" style="cursor: pointer;display: inline-block;width: 15px;height: 15px;border: 1px solid #979797;border-radius: 50%;font-size: 13px;color: #979797;text-align: center;line-height: 15px;">5</span>
                                        </span>
                                        <span style="display: block;margin-top: 20px">评分 （1-5分）</span>
                                    </p>

                                </el-col>
                                <el-col v-else-if="obj.item_type === 'STAR'" :span="8" style="background: rgba(74,144,226,0.1);height: 100%">
                                    <p style="margin-left:10px;margin-top:20px;height: 100%;text-align: center">
                                        <el-rate
                                                v-model="start"
                                                disabled
                                                score-template="{start}"
                                                 style="display: inline-block" allow-half="true" disabled-void-color="rgb(198, 209, 222);"></el-rate>
                                        <span style="display: block;margin-top: 20px">星级（每颗星两分）</span>
                                    </p>
                                </el-col>
                                <el-col v-else-if="obj.item_type === 'OPTION'" :span="8" style="background: rgba(74,144,226,0.1);">
                                    <p style="margin-left:10px;margin-top:20px;">
                                        <span style="font-size: 15px;color: #4A90E2;margin-top:10px;">评估结果</span>
                                        <el-select v-model="value" placeholder="选项1" style="width: 75%;" clearable>
                                            <el-option
                                                    v-for="item in options"
                                                    :key="item.value"
                                                    :label="item.label"
                                                    :value="item.value">
                                            </el-option>
                                        </el-select>
                                    </p>
                                    <p style="font-size: 16px;color: #4A4A4A;margin-left:30px;margin-top:15px;margin-bottom: 20px;">
                                        <el-input
                                                type="textarea"
                                                autosize
                                                placeholder="请输入内容"
                                                :autosize="{ minRows: 4}"
                                                v-model="textarea1"
                                                style="width: 95%;">
                                        </el-input>
                                    </p>
                                </el-col>
                            </el-col>
                        </el-col>
                    </el-row>
                </el-col>
            </el-row>

        </el-dialog>
<!--        协访评估详情-->
        <el-dialog
                :visible.sync="detailsBool"
                width="70%"
                :show-close="false"
                style="vertical-align: center;: #FFF9F3;padding-top: 0">
            <div style="">
                <el-row style="border-bottom: 2px dotted #e7eaec;padding-bottom: 10px;">
                    <el-col :span="12">
                        <div style="color: #3998F7;font-size: 22px;padding-top: 5px">协访评估详情
                        </div>
                    </el-col>
                    <el-col :span="12">
                        <div align="right">
                            <el-button type="warning" v-if="onoffForm" size="small" @click="upDataDteails" >
                                <i :class="['iconfont', 'el-icon-s-promotion']" style="line-height: 0"></i>
                                提交评估结果
                            </el-button>
                            <el-button type="primary" size="small" v-if="onoffForm" @click="upDataDetailsFrom">
                                保存
                            </el-button>
                            <el-button type="danger" size="small" @click="detailsBool = false">
                                关闭
                            </el-button>
                        </div>
                    </el-col>
                </el-row>
            </div>
            <el-row>
                <el-col style="margin-top: 10px;padding: 0 20px;">
                    <p style="margin: 10px 0;font-size: 18px;color: #4D586D;">{{detailsInfo.from_name}}</p>
                    <p style="margin:0;font-size: 14px;color: #B0B5B9;">协访人：{{detailsInfo.title}}<span
                            style="float: right;line-height: 0;"><span
                            style="font-size:30px;color: #87909A;">{{detailsInfo.final_score}}</span><span
                            style="font-size: 18px;color: #87909A;">分
                    </span></span></p>
                    <P style="margin: 10px 0px;font-size: 14px;color: #7ED321;">{{detailsInfo.start_time |
                        filterMergeDate(detailsInfo.end_time)}}<span
                                :style="{'color': (detailsInfo.submitted_date !== '')? '#7ED321' :
                                '#FF9901'}"
                            style="float: right;">{{detailsInfo.submitted_date | filterDetailsInfo }}
                    </span></P>
                </el-col>
                <el-col :span="24" style="max-height: 700px;padding: 0 20px;overflow: auto">
                    <el-row>
                        <el-col v-for="(item,i) in detailsInfo.category_array" :key="i" style="margin-top: 10px">
                            <p>{{item.name}} ( {{item.items}}个项目 )</p>
                            <el-col v-for="(obj,j) in item.item_array" :key="j"
                                    style="border: 1px solid #979797;margin-bottom: 10px;">
                                <el-col :span="12">
                                    <p style="margin: 10px 20px;font-size: 15px;color: #F5A623;">{{j+1}}、{{obj
                                        .item_title}}</p>
                                    <P style="margin: 5px 20px;font-size: 15px;color: #ADB3B8;">要求：</P>
                                    <p
                                            style="margin: 0px 20px;margin-bottom: 10px;font-size: 15px;color:#ADB3B8;">
                                    </p>
                                </el-col>
                                <!--                            右侧通过判断显示不同类型-->
                                <el-col v-if="obj.item_type === 'TRUE-FALSE'" :span="12" style="background:rgba(74,144,226,0.1);">
                                    <p style="margin-left: 10px;margin-top:20px;">
                                    <span style="font-size: 15px;color: #4A90E2;margin-top:10px;">评估结果</span>
                                    <span style="float:right;margin-right: 10px;line-height: 0;margin-top:-10px;">
                                            <span v-if="obj.passed === 'PASSED'"
                                                  @click="upDataSheetTable(obj,'success')"
                                                  style="display: inline-block;width: 26px;height: 26px;border:1px
                                            solid #6BC235;border-radius: 50%;">
                                                <img :src="radio_qualified"/>
                                            </span>
                                            <span v-else
                                                  @click="upDataSheetTable(obj,'danger')"
                                                  style="display: inline-block;width: 26px;height: 26px;border:1px
                                            solid #6BC235;border-radius: 50%;">
                                                <img :src="huiseyuangou" width="26" height="26" />
                                            </span>

                                            <span style="padding: 0px 10px;">
                                                <img src="../../../assets/images/line.png"/>
                                            </span>
                                            <span v-if="obj.passed === 'DENIED'"
                                                  @click="upDataSheetTable(obj,'denied')"
                                                  style="display: inline-block;width: 26px;height: 26px;">
                                                <img  :src="radio_unqualified"/>
                                            </span>
                                            <span v-else
                                                  @click="upDataSheetTable(obj,'deniedDanger')"
                                                  style="display: inline-block;width:26px;height: 26px;">
                                                <img width="26" height="26" :src="unqualifiedGray"/>
                                            </span>
                                        </span>
                                </p>
                                    <p style="font-size: 16px;color: #4A4A4A;margin-left:30px;margin-top:15px;margin-bottom: 20px;">
                                        <el-input
                                                :disabled="onoffForm === false"
                                                type="textarea"
                                                autosize
                                                placeholder="请输入内容"
                                                :autosize="{ minRows: 4}"
                                                v-model="obj.comments"
                                        style="width: 95%;">
                                        </el-input>
                                    </p>
                                </el-col>
                                <el-col v-else-if="obj.item_type === 'SCORE'" :span="12" style="background:rgba(74,144,226,0.1);">
                                    <p style="margin-left:10px;margin-top:20px;">
                                        <span style="font-size: 15px;color: #4A90E2;margin-top:10px;">评估结果</span>
                                        <span style="float: right;margin-right:10px;">
                                            <span @click="scoreHanlder1(obj,k)" v-for="(scoreInfo,k) in 10"
                                                  :class="{scoreActive:obj.score ==k+1}"
                                                  style="cursor: pointer;display: inline-block;width: 15px;height:
                                                  15px;border: 1px solid #979797;border-radius: 50%;font-size: 13px;color: #979797;
                                                  text-align: center;line-height: 15px;margin-left: 4px">{{k+1}}</span>
                                        </span>
                                    </p>
                                    <p style="font-size: 16px;color: #4A4A4A;margin-left:30px;margin-top:15px;margin-bottom: 20px;">
                                        <el-input
                                                type="textarea"
                                                :disabled="onoffForm === false"
                                                autosize
                                                placeholder="请输入内容"
                                                :autosize="{ minRows: 4}"
                                                v-model="obj.comments"
                                                style="width: 95%;">
                                        </el-input>
                                    </p>
                                </el-col>
                                <el-col v-else-if="obj.item_type === 'SCORE5'" :span="12" style="background:rgba(74,144,226,0.1);">
                                    <p style="margin-left:10px;margin-top:20px;">
                                        <span style="font-size: 15px;color: #4A90E2;margin-top:10px;">评估结果</span>
                                        <span style="float: right;margin-right:10px;">
                                            <span @click="scoreHanlder1(obj,k)" v-for="(scoreInfo,k) in 5"
                                                  :class="{scoreActive:obj.score ==k+1}"
                                                  style="cursor: pointer;display: inline-block;width: 15px;height:
                                                  15px;border: 1px solid #979797;border-radius: 50%;font-size: 13px;color: #979797;
                                                  text-align: center;line-height: 15px;margin-left: 4px">{{k+1}}</span>
                                        </span>
                                    </p>
                                    <p style="font-size: 16px;color: #4A4A4A;margin-left:30px;margin-top:15px;margin-bottom: 20px;">
                                        <el-input
                                                type="textarea"
                                                :disabled="onoffForm === false"
                                                autosize
                                                placeholder="请输入内容"
                                                :autosize="{ minRows: 4}"
                                                v-model="obj.comments"
                                                style="width: 95%;">
                                        </el-input>
                                    </p>
                                </el-col>
                                <el-col v-else-if="obj.item_type === 'STAR'" :span="12" style="background: rgba(74,144,226,0.1);">
                                        <p style="margin-left:10px;margin-top:20px;">
                                            <span style="font-size: 15px;color: #4A90E2;margin-top:10px;">评估结果</span>
                                            <el-rate v-model="obj.stars"  :disabled="onoffForm === false"
                                                     style="display: inline-block;float: right;margin-top:-5px;" allow-half="true" disabled-void-color="rgb(198, 209, 222);"></el-rate>
                                        </p>
                                        <p style="font-size: 16px;color: #4A4A4A;margin-left:30px;margin-top:15px;margin-bottom: 20px;">
                                            <el-input
                                                    type="textarea"
                                                    :disabled="onoffForm === false"
                                                    autosize
                                                    placeholder="请输入内容"
                                                    :autosize="{ minRows: 4}"
                                                    v-model="obj.comments"
                                                    style="width: 95%;">
                                            </el-input>
                                        </p>
                                    </el-col>
                                <el-col v-else :span="12" style="background: rgba(74,144,226,0.1);">
                                    <p style="margin-left:10px;margin-top:20px;">
                                        <span style="font-size: 15px;color: #4A90E2;margin-top:10px;">评估结果</span>
                                        <el-select v-model="obj.score" placeholder=""
                                                   :disabled="onoffForm === false"
                                                   style="float: right;margin-right: 28px" clearable>
                                            <el-option
                                                    v-for="item in options"
                                                    :key="item.value"
                                                    :label="item.label"
                                                    :value="item.value">
                                            </el-option>
                                        </el-select>
                                    </p>
                                    <p style="font-size: 16px;color: #4A4A4A;margin-left:30px;margin-top:15px;margin-bottom: 20px;">
                                        <el-input
                                                type="textarea"
                                                autosize
                                                :disabled="onoffForm === false"
                                                placeholder="请输入内容"
                                                :autosize="{ minRows: 4}"
                                                v-model="obj.comments"
                                                style="width: 95%;">
                                        </el-input>
                                    </p>
                                </el-col>
                                </el-col>
                        </el-col>
                    </el-row>
                </el-col>
            </el-row>
        </el-dialog>
<!--        写一笔-->
        <el-dialog
                id="travelSavePlanPs"
                :visible.sync="modelSavePlanPs"
                :show-close="false"
                style="vertical-align: center;: #FFF9F3">
            <div style="">
                <el-row style="border-bottom: 2px dotted #e7eaec;padding-bottom: 10px;">
                    <el-col :span="12">
                        <div style="color: #3998F7;padding-top: 8px;font-size: 20px">写一笔
                        </div>
                    </el-col>

                    <el-col :span="12">
                        <div align="right">
                            <el-button type="primary" size="small" @click="savePlanPs()">
                                保存
                            </el-button>
                            <el-button type="danger" size="small" @click="modelSavePlanPs = false">
                                关闭
                            </el-button>
                        </div>
                    </el-col>
                </el-row>
            </div>
            <div style="margin-top: 20px">
                <el-input type="textarea" v-model="contents"> </el-input>

            </div>
        </el-dialog>
    </div>
</template>

<script>
import tutorBar from "../../../components/tutorBar";
import http from "../../../APIService/http";
import radio_unqualified from "../../../assets/images/radio_unqualified.png";
import radio_qualified from "../../../assets/images/radio_qualified.png";
import unqualifiedGray from "../../../assets/images/unqualifiedGray.png";
import check from "../../../assets/images/check.png";
import huiseyuangou from "../../../assets/images/huiseyuangou.png";
import tou from "../../../assets/images/tou.png";
import moment from "moment";
import tutoring from "./tutoring";
import { Message } from "element-ui";
export default {
  name: "medical",
  data() {
    const validateTime = (rule, value, callback) => {
      if (this.form.start_time === "" || this.form.end_time === "") {
        callback(new Error("协访日期不能为空"));
      } else {
        callback();
      }
    };
    return {
      title: "",
      id: "",
      loading: false,
      assistBool: false,
      assist: false,
      assessBool: false,
      value1: 3,
      detailsBool: false,
      modelSavePlanPs: false,
      contents: "",
      score: "",
      data: {},
      tags: ["辖区事务", "辅导/协访"],
      activeName: "医疗机构",
      options: [],
      value: [],
      optionTerritoryList: [],
      form: {
        activity_id: "",
        activity_date: "",
        clientInfo_array: [],
        client_array: [],
        coach_id: "",
        coach_name: "",
        coachee_id: "",
        coachee_name: "",
        coaching_type: "",
        coaching_type_name: "",
        completed: "",
        confirmed_date: "",
        confirmed_result: "",
        created_by: "",
        dateArray: [],
        dateStr: "",
        end_time: "",
        formInfo_array: [],
        form_array: [],
        ps_Array: [],
        start_time: "",
        status: "",
        submitted_date: "",
        textIndeed: "",
        title: "",
        territory_id: "",
      },
      copyForm: {
        activity_id: "",
        activity_date: "",
        clientInfo_array: [],
        client_array: [],
        coach_id: "",
        coach_name: "",
        coachee_id: "",
        coachee_name: "",
        coaching_type: "",
        coaching_type_name: "",
        completed: "",
        confirmed_date: "",
        confirmed_result: "",
        created_by: "",
        dateArray: [],
        dateStr: "",
        end_time: "",
        formInfo_array: [],
        form_array: [],
        ps_Array: [],
        start_time: "",
        status: "",
        submitted_date: "",
        textIndeed: "",
        title: "",
      },
      optionVisitorList: [], //协访人数组
      optionUnVisitorList: [], //被协访人数组
      optionCoachingTypeList: [],
      detailsInfo: {},
      radio_unqualified: radio_unqualified,
      radio_qualified: radio_qualified,
      unqualifiedGray: unqualifiedGray,
      check: check,
      huiseyuangou: huiseyuangou,
      addVisitForm: {
        institutionsArray: [],
        distributorArray: [],
        retailstoreArray: [],
      },
      copyAddVisitForm: {
        institutionsArray: [],
        distributorArray: [],
        retailstoreArray: [],
      },
      addCoachingFromList: {
        coachingFromArray: [],
        smallFromArray: [],
      },
      copyAddCoachingFromList: {
        coachingFromArray: [],
        smallFromArray: [],
      },
      status: "", //new新增  info详情
      start: 4,
      stars: 0,
      onoffCoachee: false,
      onoffCoach: false,

      //权限判断
      parameter_value: false, //是否需要审批
      onoffAssess: false, //添加协访评估按钮
      onoffAssist: true, //添加协访客户按钮
      onoffSave: false, //保存按钮
      deleteOnOff: false, //删除按钮
      onoffSubmit: false, //提交按钮
      onoffAgreed: false, //同意按钮
      onoffSuccess: false, //完成按钮
      onoffRefused: false, //拒绝按钮
      onoffForm: false, //评估表详情是否可以修改
      onoffFormCoach: false, //协访表单禁用按钮
      onlyReading: false, //控制所有是否只读
      onoffPlan: false, //是否显示写一笔
      writePenBtnOnOff: true, //是否隐藏添加写一笔按钮
      onoffAssessLength: true, //协访评估文字显示
      onoffAssistLength: true, //协访客户文字显示
      onoffisEdit: false,
      onoffRecord: false, //协访计划 or 协访记录
      onoffAccordingRecord: false, //显示 协访记录/计划 滑块
      onofTerritory: false,
      selectTerritory: false,

      onoffSwitch: true,
      pickerMaxDate: "",
      pickerMinDate: "",
      choiceDate: "",
      valuetime1: "00:00:00",
      valuetime2: "00:01:00",
      pickerOptions0: {
        disabledDate: (time) => {
          return time.getTime() < Date.now();
        },
      },
      isStaff: this.$store.getters.getUser.role === "staff",
      pickerOptions1: {
        // disabledDate: (time) => {
        //     let valueTime = moment(this.form.start_time).endOf('day').valueOf()
        //     return time.getTime() < moment(this.form.start_time).valueOf() || time.getTime() > valueTime
        // }
      },
      pickerOptions2: {
        disabledDate: (time) => {
          return time.getTime() > Date.now();
        },
      },
      pickerOptions3: {},
      rules: {
        date: [{ required: true, validator: validateTime, trigger: "blur" }],
      },
      dateRange: [],
      clientObj: {},
    };
  },
  filters: {
    filterDate: function (value) {
      return moment(value).format("MM月DD日");
    },
    filterCheck: function (value, type) {
      if (type === "in") {
        if (value === null || value === "") {
          return "尚未签入";
        } else {
          return "签入：" + moment(value).format("HH:mm:ss");
        }
      } else {
        if (value === null || value === "") {
          return "尚未签出";
        } else {
          return "签入：" + moment(value).format("HH:mm:ss");
        }
      }
    },
    filterMergeDate: function (value1, value2) {
      return (
        moment(value1).format("YYYY年MM月DD日 HH:mm") +
        "-" +
        moment(value2).format("HH:mm")
      );
    },
    componentFliter: function (value) {
      return moment(value).format("YYYY-M-D HH:mm:ss");
    },
    filterCustomerName: function (value) {
      if (value.institution_name) {
        return value.institution_name;
      } else if (value.store_name) {
        return value.store_name;
      } else if (value.distributor_name) {
        return value.distributor_name;
      }
    },
    filterCustomerGrade: function (value) {
      if (value.institution_grade) {
        return value.institution_grade;
      } else if (value.retailstore_grade) {
        return value.retailstore_grade;
      } else if (value.distributor_grade) {
        return value.distributor_grade;
      }
    },
    filterStart(i) {
      return parseFloat(i.stars) / 2;
    },
    filterDetailsInfo(i) {
      if (i !== "") {
        return "评估已完成";
      } else {
        return "尚未完成";
      }
    },
  },
  components: {
    tutorBar,
    // Upload
  },
  watch: {

    form: {
      handler(n, o) {
        for (let i = 0; i < this.optionVisitorList.length; i++) {
          if (n.coach_id === this.optionVisitorList[i].owner_id) {
            n.coach_name = this.optionVisitorList[i].owner_name;
          }
        }
        for (let j = 0; j < this.optionUnVisitorList.length; j++) {
          if (n.coachee_id === this.optionUnVisitorList[j].owner_id) {
            n.coachee_name = this.optionUnVisitorList[j].owner_name;
          }
        }
      },
      // immediate: true,  //刷新加载 立马触发一次handler
      deep: true, // 可以深度检测到 person 对象的属性值的变化
    },
    "form.coachee_id"(n, o) {
      this.getInstutionsList();
      this.getDistributorList();
      this.getRetailstoreList();
    },
    status(n, o) {
      if (n === "INFO") {
        this.onoffPlan = true;
      } else if (n === "NEW") {
        this.onoffPlan = false;
      }

      if (this.form.completed === "T") {
        this.writePenBtnOnOff = false;
      }
    },
    dateRange: {
      handler(nv, ol) {
        if (nv && nv.length > 0) {
          this.form.start_time = nv[0];
          this.form.end_time = nv[1];
        } else {
          this.form.start_time = "";
          this.form.end_time = "";
        }
      },
      deep: true,
    },
  },
  async created() {
    await this.isSubmitCoVisitor();
    await this.getCoVisitorList("COACH");

    if (this.isStaff) {
      await this.getUnCoVisitorList("COACHEE");
    }
    this.clientObj = this.$store.getters.getClient;
    await this.getCoachingTypeList();
    await this.getTerritoryList();
  },
  mounted() {
    // console.log(moment(new Date(2016, 9, 10, 8, 40)).format('YYYY-MM-DD HH:mm'))
    // document.getElementById('main').scrollTo(0, 0)

    let user = this.$store.getters.getUser;

    if (user.role !== "staff") {
      this.onoffAssess = true;
      this.onoffAssist = true;
      this.onoffCoach = true;
      this.onoffAccordingRecord = true;
      this.onofTerritory = true;
    } else {
      this.onoffCoachee = true;
      this.onoffAssessLength = false;
      this.onoffAccordingRecord = false;
      this.onofTerritory = false;
    }

    if (this.$route.params.type === "new") {
      this.status = "NEW";
      this.onoffSave = true;
      if (this.$route.params.addType === "plan" && this.parameter_value) {

        this.onoffSubmit = true;
      } else if (this.$route.params.addType === "record") {
        this.onoffSubmit = false;
      }
      this.form.coachee_name = user.alias;
      if (user.role !== "staff") {
        this.onoffSwitch = false;
        this.form.coach_id = user.user_id;
      } else {
        this.form.coachee_id = user.user_id;
        this.onoffSwitch = true;
      }
      this.getInstutionsList();
      this.getDistributorList();
      this.getRetailstoreList();
      this.getCoachingFromList();
    } else if (Object.keys(this.$route.params).length === 0) {
      let condition = localStorage.getItem("condition");
      this.status = "INFO";
      this.data = JSON.parse(condition);
      this.onoffPlan = true;
      this.onoffAccordingRecord = false;
      this.init();
    } else {
      this.status = "INFO";
      this.data = this.$route.params;
      this.onoffPlan = true;
      this.onoffAccordingRecord = false;
      this.init();
    }
    if (this.$route.params.addType === "plan") {
      this.onoffRecord = false;
    } else if (this.$route.params.addType === "record") {
      this.onoffRecord = true;
    }
    if (!this.isStaff && this.status == "INFO") {
      this.getUnCoVisitorList("COACHEE");
    }

    // this.getCoachingFromList()
  },
  updated() {},
  methods: {
    addAssessBoolModel() {
      this.copyForm.formInfo_array = JSON.parse(
        JSON.stringify(this.form.formInfo_array)
      );
      this.copyAddCoachingFromList = JSON.parse(
        JSON.stringify(this.addCoachingFromList)
      );
      this.assessBool = false;
    },
    closeAssessBool() {
      this.form.formInfo_array = JSON.parse(
        JSON.stringify(this.copyForm.formInfo_array)
      );
      this.addCoachingFromList = JSON.parse(
        JSON.stringify(this.copyAddCoachingFromList)
      );
      this.assessBool = false;
    },
    addAssistBool() {
      this.copyForm.clientInfo_array = JSON.parse(
        JSON.stringify(this.form.clientInfo_array)
      );
      this.copyAddVisitForm = JSON.parse(JSON.stringify(this.addVisitForm));
      this.assistBool = false;
    },
    closeAssistBool() {
      this.assistBool = false;
      this.form.clientInfo_array = JSON.parse(
        JSON.stringify(this.copyForm.clientInfo_array)
      );
      this.addVisitForm = JSON.parse(JSON.stringify(this.copyAddVisitForm));
    },
    recordSwitch(i) {
      this.form.start_time = "";
      this.form.end_time = "";
    },
    async chooseTimeRangeTow(t) {
      let dateA = new Date(t[0]);
      let dateB = new Date();
      let timeOnoff = dateA.setHours(0, 0, 0, 0) == dateB.setHours(0, 0, 0, 0);
      if (timeOnoff) {
        this.dateRange = [];
      }

      let time1 = moment(t[1]).valueOf();
      let time2 = moment(t[0]).valueOf();
      let day1 = parseFloat(moment(t[1]).format("D"));
      let day2 = parseFloat(moment(t[0]).format("D"));
      let dateAT = new Date(t[1]);
      let dateBT = new Date(t[0]);
      let timeOnoffT =
        dateAT.setHours(0, 0, 0, 0) == dateBT.setHours(0, 0, 0, 0);
      if (day1 - day2 >= 1) {
        if (timeOnoffT == false || time1 <= time2) {
          this.$message({
            type: "warning",
            message: "所选的时间不能跨天",
          });
          this.dateRange = [];
        }
      } else if (time2 >= time1) {
        this.$message({
          type: "warning",
          message: "结束时间应晚于开始时间",
        });
        this.dateRange = [];
      } else {
        if (t[0]) {
          this.form.start_time = t[0];
        }
        if (t[1]) {
          this.form.end_time = t[1];
        }
        await this.getCoVisitorList("COACH");
        await this.getUnCoVisitorList("COACHEE");
      }
    },
    chooseTimeRange0(t) {
      let dateA = new Date(t);
      let dateB = new Date();
      let timeOnoff = dateA.setHours(0, 0, 0, 0) == dateB.setHours(0, 0, 0, 0);
      if (timeOnoff) {
        this.form.start_time = "";
      }
    },
    chooseTimeRange1(t) {
      let time1 = moment(t).valueOf();
      let time2 = moment(this.form.start_time).valueOf();
      let day1 = moment(this.form.start_time).format("DD");
      let day2 = moment(t).format("DD");
      let dateA = new Date(t);
      let dateB = new Date(this.form.start_time);
      let timeOnoff = dateA.setHours(0, 0, 0, 0) == dateB.setHours(0, 0, 0, 0);
      if (day2 - day1 < 1) {
        if (timeOnoff === false || time1 <= time2) {
          this.$message({
            type: "warning",
            message: "结束时间应晚于开始时间",
          });
          this.form.end_time = "";
        }
      } else if (day2 - day1 >= 1) {
        this.$message({
          type: "warning",
          message: "所选的时间不能跨天",
        });
        this.form.end_time = "";
      }
    },
    chooseTimeRangeOne(t) {
      let time1 = moment(t[1]).valueOf();
      let time2 = moment(t[0]).valueOf();
      let day1 = parseFloat(moment(t[1]).format("D"));
      let day2 = parseFloat(moment(t[0]).format("D"));
      let dateA = new Date(t[1]);
      let dateB = new Date(t[0]);
      let timeOnoff = dateA.setHours(0, 0, 0, 0) == dateB.setHours(0, 0, 0, 0);
      if (day1 - day2 > 1) {
        if (timeOnoff === false || time1 <= time2) {
          this.$message({
            type: "warning",
            message: "所选的时间不能跨天",
          });
          this.dateRange = [];
        }
      } else if (time2 > time1) {
        this.$message({
          type: "warning",
          message: "结束时间应晚于开始时间",
        });
        this.dateRange = [];
      } else {
        if (t[0]) {
          this.form.start_time = t[0];
        }
        if (t[1]) {
          this.form.end_time = t[1];
        }
        this.getCoVisitorList("COACH");
        this.getUnCoVisitorList("COACHEE");
      }
    },
    chooseTimeRange2(t) {},
    chooseTimeRange3(t) {
      let time1 = moment(t).valueOf();
      let time2 = moment(this.form.start_time).valueOf();
      let day1 = moment(this.form.start_time).format("DD");
      let day2 = moment(t).format("DD");
      let dateA = new Date(t);
      let dateB = new Date(this.form.start_time);
      let timeOnoff = dateA.setHours(0, 0, 0, 0) == dateB.setHours(0, 0, 0, 0);
      if (day2 - day1 < 1) {
        if (timeOnoff === false || time1 <= time2) {
          this.$message({
            type: "warning",
            message: "结束时间应晚于开始时间",
          });
          this.form.end_time = "";
        }
      } else if (day2 - day1 >= 1) {
        this.$message({
          type: "warning",
          message: "所选的时间不能跨天",
        });
        this.form.end_time = "";
      }
    },
    filterDetails(item, i) {
      let user = this.$store.getters.getUser;
      if (user.user_id === this.form.coach_id || item.submitted_date !== "") {
        return true;
      } else {
        return false;
      }
    },
    async init() {
      let loading = this.$loading({
        lock: true,
        text: "拼命加载中",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      try {
        let user = this.$store.getters.getUser;
        let data = {
          tenant_id: user.tenant_id,
          user_id: user.user_id,
          activity_id: this.data.activity_id,
        };
        await http.post("/wapi/Tutoring/getCoachingInfo", data).then((res) => {
          if (res.success === true) {
            let coachObj = res.data;
            if (this.status == "INFO" && this.onofTerritory) {
              // this.optionTerritoryList=[]
              this.getCoacheeTerritory(coachObj);
            }

            // console.log(res.data,22)

            this.judeg(coachObj);
            this.getInstutionsList();
            this.getDistributorList();
            this.getRetailstoreList();
            this.getCoachingFromList();

            if (res.data.isClosed == "T") {
              this.onoffAssist = false;
              this.onoffAssess = false;
              this.writePenBtnOnOff = false;
              this.onoffSubmit = false;
              this.onoffSave = false;
              this.onoffRefused = false;
              this.deleteOnOff = false;
              this.onoffAgreed = false;
              this.onoffSuccess = false;
              this.onoffForm = false;
              this.onoffFormCoach = true;
              this.selectTerritory = true;
            }
            loading.close();
          }
        });
      } catch (e) {
        loading.close();
      }
    },
    judeg(arr) {

      let obj = arr;

      obj.dateStr =
        moment(obj.start_time).format("YYYY年M月D日 HH:mm") +
        "-" +
        moment(obj.end_time).format("HH:mm");

      if (obj.submitted_date === "") {
        obj.textIndeed = "计划未提交";
      }

      if (!(obj.submitted_date === "") && obj.confirmed_date === "") {
        obj.textIndeed = "计划待确认";
      }

      if (!(obj.confirmed_date === "") && obj.confirmed_result === "APPROVED") {
        obj.textIndeed = "计划已确认";
      }

      if (!(obj.confirmed_date === "") && obj.confirmed_result === "DENIED") {
        obj.textIndeed = "计划被拒绝";
      }
      if (obj.completed === "T") {
        obj.textIndeed = "协访已完成";
      }
      if (obj.confirmed_resultText === "") {
        obj.textIndeed = "计划进行中";
      }
      if (obj.status === "ACTIVE") {
        this.onoffRecord = true;
      } else {
        this.onoffRecord = false;
      }

      // obj.dateArray=[]
      // let startTime = moment(obj.start_time).format('YYYY-MM-DD HH:mm')
      // let endTime = moment(obj.end_time).format('YYYY-MM-DD HH:mm')
      //  obj.dateArray.push(startTime)
      //  obj.dateArray.push(endTime)

      let user = this.$store.getters.getUser;

      if (user.role !== "staff") {
        this.onoffFormCoach = true;
        this.onoffAgreed = false;
        this.onoffAssess = false;
        this.onoffAssist = false;
        this.onoffSubmit = false;
        this.onoffSave = false;
        this.onoffRefused = false;
        this.deleteOnOff = false;
      }
      //判断是否完成，其他管理者只能查看
        if (obj.formInfo_array.length > 0) {

            for(let v of obj.formInfo_array){

                let database = this.$store.getters.getUser.database;

                if(this.$store.getters.getUser.tenant_id == '1472813522'){
                    if(parseInt(v.final_score)< 60){
                        v.evaluation = '差'
                    }else if( parseInt(v.final_score)>= 60 && parseInt(v.final_score)<= 85){
                        v.evaluation = '良好'
                    }else {
                        v.evaluation = '优秀'
                    }
                }
            }

        }

      if (
        obj.completed === "T" ||
        (user.user_id !== obj.coach_id && user.user_id !== obj.coachee_id)
      ) {
        //是否显示评估

        if (obj.formInfo_array.length > 0) {
          this.onoffAssess = true;
          this.onoffForm = false;
        }
        //去掉所有操作只能读
        this.onlyReading = true;
        this.writePenBtnOnOff = false;
      } else {
        //显示保存按钮
        this.onoffSave = true;
        //this.deleteOnOff = true
        //判断是否为自己创建

        if (obj.created_by === user.user_id) {
          if (obj.formInfo_array.length > 0) {
            this.onoffAssess = true;
          }
          if (obj.status === "SUBMITTED") {
            //已提交
            //计划确认中 禁止删除和编辑
            this.onlyReading = true;
            this.onoffSave = false;
            this.onoffSubmit = false;
            this.deleteOnOff = false;
            this.onoffAccordingRecord = false;
          } else {
            if (obj.confirmed_result === "APPROVED") {
              // this.onlyReading = true
              //计划以确认
              this.onoffSave = false;
              this.onoffisEdit = true;
              this.deleteOnOff = false;
              this.onoffFormCoach = true;
              this.selectTerritory = false;
              this.onoffAssist = false;
              this.onoffAssess = false;
              //判断当前人是否为管理员，确认后显示显示完成按钮
              if (user.role === "staff") {
              } else {
                this.onoffSuccess = true;
                this.onoffForm = true;
                this.onoffAssess = true;
                this.onoffAssist = true;
                this.onoffSave = true;
              }
            } else if (obj.confirmed_result === "DENIED") {
              if (this.parameter_value) {

                this.onoffSubmit = true;
              } else {
                this.onoffSubmit = false;
              }

              //拒绝了次计划，直接隐藏保存按钮
              this.onoffFormCoach = false;
              this.selectTerritory = false;
              this.onoffSave = false;
              this.deleteOnOff = true;
              if (user.role === "staff") {
                this.onoffAssess = false;
              } else {
                this.onoffAssess = true;
                this.onoffAssist = true;
              }
            } else {
              //未提交。显示提交按钮
              if (this.parameter_value) {

                this.onoffSubmit = true;

              } else {
                this.onoffSubmit = false;
              }
              this.deleteOnOff = true;
              this.onoffFormCoach = false;
              this.selectTerritory = false;
              this.onoffForm = true;
              //主管可新增
              if (user.role !== "staff") {
                this.onoffAssess = true;
              }
              this.onoffAssist = true;
              this.onoffisEdit = true;
            }
          }
        } else {
          this.onoffAssist = false;
          this.onoffFormCoach = true;
          this.selectTerritory = false;

          if (obj.status === "SUBMITTED") {
            //已提交
            this.onoffRefused = true; //拒绝
            this.onoffAgreed = true; //同意
            if (user.role !== "staff") {
              //只有主管显示保存按钮
              this.onoffSave = true;
              this.deleteOnOff = false;
              this.onoffAssess = true;
            } else {
              this.onoffSave = false;
              this.deleteOnOff = false;
            }
          } else {
            if (obj.confirmed_result === "APPROVED") {
              if (user.role !== "staff") {
                //显示完成按钮
                this.onoffSuccess = true;
                //评估表可编辑
                this.onoffForm = true;
                //主管可新增
                this.selectTerritory = true;
                this.onoffAssess = true;
                this.onoffAssist = true;
                this.onoffisEdit = true;
              } else {
                this.onoffSave = false;
                this.onoffAgreed = false;
                this.onoffRefused = false;
              }
            } else if (obj.confirmed_result === "DENIED") {
              this.onoffAgreed = false;
              this.onoffRefused = false;
              this.onoffSave = false;
              if (user.role !== "staff") {
                this.onoffAssess = true;
              }
            } else {
              //未提交
              //显示保存按钮
              this.onoffSave = true;
              this.deleteOnOff = true;
              if (obj.created_by !== user.user_id) {
                this.onoffSave = false;
                this.deleteOnOff = false;
              }
            }
          }
        }
      }
      if (this.onlyReading) {
        this.onoffFormCoach = true;
        this.selectTerritory = true;
        this.onoffAgreed = false;
        this.onoffAssess = false;
        this.onoffAssist = false;
        this.onoffSubmit = false;
        this.onoffSave = false;
        this.onoffRefused = false;
        this.deleteOnOff = false;
        this.onoffForm = false;
        this.onoffSuccess = false;
      }

      //判断是不是协访记录 并且只允许主管填写，不需要提交计划，不需要代表确认。
      if (obj.status === "ACTIVE") {
        if (user.role === "staff") {
          this.onoffFormCoach = true;
          this.selectTerritory = true;
          this.onoffAgreed = false;
          this.onoffAssess = false;
          this.onoffAssist = false;
          this.onoffSubmit = false;
          this.onoffSave = false;
          this.onoffRefused = false;
          this.deleteOnOff = false;
          this.onoffForm = false;
          this.onoffSuccess = false;
        } else {
          this.onoffFormCoach = false;
          this.selectTerritory = false;
          this.onoffAgreed = false;
          this.onoffAssess = true;
          this.onoffAssist = true;
          this.onoffSubmit = false;
          this.onoffSave = true;
          this.onoffRefused = false;
          this.deleteOnOff = true;
          this.onoffForm = true;
          this.onoffSuccess = false;
        }
      }

      for (let j = 0; j < obj.formInfo_array.length; j++) {
        if (obj.formInfo_array[j] === "尚未完成") {
          obj.formInfo_array[j].onoff = true;
        } else {
          obj.formInfo_array[j].onoff = false;
        }
      }

      if (this.onoffAssist === false && obj.clientInfo_array.length === 0) {
        this.onoffAssistLength = false;
      } else {
        this.onoffAssistLength = true;
      }
      if (this.onoffAssess === false && obj.formInfo_array.length === 0) {
        this.onoffAssessLength = false;
      } else {
        this.onoffAssessLength = true;
      }

      this.form = obj;
      this.copyForm = JSON.parse(JSON.stringify(obj));
      this.dateRange = [this.form.start_time, this.form.end_time];
      for (let i = 0; i < obj.formInfo_array.length; i++) {
        for (let j = 0; j < obj.formInfo_array[i].category_array.length; j++) {
          for (
            let k = 0;
            k < obj.formInfo_array[i].category_array[j].item_array.length;
            k++
          ) {
            if (
              obj.formInfo_array[i].category_array[j].item_array[k]
                .item_type === "STAR"
            ) {
              obj.formInfo_array[i].category_array[j].item_array[k].stars =
                parseFloat(
                  obj.formInfo_array[i].category_array[j].item_array[k].stars
                ) / 2;
            }
          }
        }
      }

      for (let j = 0; j < this.form.ps_Array.length; j++) {
        if (this.form.ps_Array[j].photo_id) {
          this.getImgUrl(this.form.ps_Array[j]);
        } else {
          this.form.ps_Array[j].src = tou;
        }
      }
      console.log(this.onoffForm,'按钮')
    },
    async getCoacheeTerritory(obj) {
      // let loading = this.$loading({
      //     lock: true,
      //     text: '拼命加载中',
      //     spinner: 'el-icon-loading',
      //     background: 'rgba(0, 0, 0, 0.7)'
      // });
      try {
        let user = this.$store.getters.getUser;
        let data = {
          tenant_id: user.tenant_id,
          user_id: user.user_id,
          coachee_id: obj.coachee_id,
          date: obj.activity_date,
        };
        await http
          .post("/wapi/Tutoring/getCoacheeTerritory", data)
          .then((res) => {
            // console.log(res.data,1111)
            if (res.success == true) {
              this.optionTerritoryList = res.data;
              this.form.territory_id = res.data[0].territory_id;
              // loading.close()
            }
          });
      } catch (e) {}
    },
    scoreHanlder1(obj, num) {
      if (this.onoffForm) {
        obj.score = num + 1;
      } else {
        return false;
      }
    },
    changeTerritory(t) {
      this.form.coachee_id = "";
      const loading = this.$loading({
        lock: true,
        text: "拼命加载中",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      try {
        let user = this.$store.getters.getUser;
        let data = {
          tenant_id: user.tenant_id,
          user_id: user.user_id,
          obj: "COACHEE",
          role: user.role,
          territory_id: t,
        };
        if (this.form.start_time) {
          data.month = moment(this.form.start_time).format("YYYY-MM");
        }
        if (this.form.end_time) {
          data.month = moment(this.form.end_time).format("YYYY-MM");
        }

        http.post("/wapi/Tutoring/getCoVisitorList", data).then((res) => {
          if (res.success === true) {
            this.optionUnVisitorList = res.data;
            if (user.role == "staff") {
              this.optionUnVisitorList = [];
              this.form.coachee_id = this.$store.getters.getUser.user_id;
              this.optionUnVisitorList.push({
                owner_name: user.alias,
                owner_id: user.user_id,
              });
            }
          }
          loading.close();
        });
      } catch (e) {
        loading.close();
      }
    },

    handleBackClick() {
      this.$router.go(-1);
    },

    async isSubmitCoVisitor() {
      let user = this.$store.getters.getUser;
      let data = {
        user_id: user.user_id,
        tenant_id: user.tenant_id,
      };
      await http.post("/wapi/Tutoring/isSubmitCoVisitor", data).then((res) => {
        if (res.data.parameter_value === "T") {
          this.onoffSubmit = true;
          this.parameter_value = true;
        } else {
          this.onoffSubmit = false;
          this.parameter_value = false;
        }
      });
    },
    async getCoVisitorList(type) {
      const loading = this.$loading({
        lock: true,
        text: "拼命加载中",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      try {
        let user = this.$store.getters.getUser;
        let data = {
          tenant_id: user.tenant_id,
          user_id: user.user_id,
          obj: type,
        };
        if (this.form.start_time) {
          data.month = moment(this.form.start_time).format("YYYY-MM");
        }
        if (this.form.end_time) {
          data.month = moment(this.form.end_time).format("YYYY-MM");
        }
        await http.post("/wapi/Tutoring/getCoVisitorList", data).then((res) => {
          if (res.success) {
            this.optionVisitorList = res.data;
            if (user.role != "staff") {
              this.optionVisitorList = [];
              this.form.coach_id = this.$store.getters.getUser.user_id;
              this.optionVisitorList.push({
                owner_name: user.alias,
                owner_id: user.user_id,
              });
            }
          }
          loading.close();
        });
      } catch (e) {
        loading.close();
      }
    },
    async getUnCoVisitorList(type) {
      const loading = this.$loading({
        lock: true,
        text: "拼命加载中",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      try {
        let user = this.$store.getters.getUser;
        let data = {
          tenant_id: user.tenant_id,
          user_id: user.user_id,
          obj: type,
          role: user.role,
        };
        if (this.form.start_time) {
          data.month = moment(this.form.start_time).format("YYYY-MM");
        }
        if (this.form.end_time) {
          data.month = moment(this.form.end_time).format("YYYY-MM");
        }
        await http.post("/wapi/Tutoring/getCoVisitorList", data).then((res) => {
          if (res.success === true) {
            this.optionUnVisitorList = res.data;
            if (user.role == "staff") {
              this.optionUnVisitorList = [];
              this.form.coachee_id = this.$store.getters.getUser.user_id;
              this.optionUnVisitorList.push({
                owner_name: user.alias,
                owner_id: user.user_id,
              });
            }
          }
          loading.close();
        });
      } catch (e) {
        loading.close();
      }
    },
    async getCoachingTypeList() {
      try {
        let user = this.$store.getters.getUser;
        let data = {
          tenant_id: user.tenant_id,
        };
        await http
          .post("/wapi/Tutoring/getCoachingTypeList", data)
          .then((res) => {
            this.optionCoachingTypeList = res.data;
          });
      } catch (e) {}
    },
    detailsBoolInfo(item) {

      this.detailsInfo = item;
      let user = this.$store.getters.getUser;
      if (
        this.form.confirmed_result === "APPROVED" &&
        user.role !== "staff" &&
        this.form.completed !== "T" &&
        item.submitted_date === ""
      ) {
        this.onoffForm = true;
      } else {
        this.onoffForm = false;
      }
      this.detailsBool = true;
    },
    async getInstutionsList() {
      try {
        let user = this.$store.getters.getUser;
        let data = {
          tenant_id: user.tenant_id,
          user_id: user.user_id,
          owner_id: this.form.coachee_id,
          city_id: [],
          grade_array: [],
        };
        await http.post("/wapi/WeekPlan/getInstutionsList", data).then((res) => {
          if (res.success === true) {
            let arr = res.data.array;
            this.checkInfoSelect(arr, "ins");
          }
        });
      } catch (e) {}
    },
    async getRetailstoreList() {
      try {
        let user = this.$store.getters.getUser;
        let data = {
          tenant_id: user.tenant_id,
          user_id: user.user_id,
          owner_id: this.form.coachee_id,
          city_id: [],
          grade_array: [],
        };
        await http
          .post("/wapi/WeekPlan/getRetailstoreList", data)
          .then((res) => {
            if (res.success === true) {
              let arr = res.data.array;
              this.checkInfoSelect(arr, "store");
            }
          });
      } catch (e) {}
    },
    async getDistributorList() {
      try {
        let user = this.$store.getters.getUser;
        let data = {
          tenant_id: user.tenant_id,
          user_id: user.user_id,
          owner_id: this.form.coachee_id,
          city_id: [],
          grade_array: [],
        };
        await http
          .post("/wapi/WeekPlan/getDistributorList", data)
          .then((res) => {
            if (res.success === true) {
              // console.log(res.data.array)
              let arr = res.data.array;
              this.checkInfoSelect(arr, "dis");
            }
          });
      } catch (e) {}
    },
    checkInfoSelect(arr, type) {
      let array1 = arr;
      let array2 = this.form.client_array;
      if (array2.length > 0) {
        for (let i = 0; i < array1.length; i++) {
          for (let j = 0; j < array2.length; j++) {
            array1[i].onoff = false;
            if (array1[i].institution_id === array2[j].id) {
              array1[i].onoff = true;
              break;
            }
            if (array1[i].store_id === array2[j].id) {
              array1[i].onoff = true;
              break;
            }
            if (array1[i].distributor_id === array2[j].id) {
              array1[i].onoff = true;
              break;
            }
          }
        }
      } else {
        for (let i = 0; i < array1.length; i++) {
          array1[i].onoff = false;
        }
      }
      if (type === "ins") {
        this.addVisitForm.institutionsArray = array1;
        this.copyAddVisitForm.institutionsArray = JSON.parse(
          JSON.stringify(array1)
        );
      } else if (type === "store") {
        this.addVisitForm.retailstoreArray = array1;
        this.copyAddVisitForm.retailstoreArray = JSON.parse(
          JSON.stringify(array1)
        );
      } else {
        this.addVisitForm.distributorArray = array1;
        this.copyAddVisitForm.distributorArray = JSON.parse(
          JSON.stringify(array1)
        );
      }
    },
    checkVisitInfoIns(item) {
      if (item.onoff === true) {
        item.onoff = false;
        for (let i = 0; i < this.form.clientInfo_array.length; ) {
          if (
            item.institution_id ===
            this.form.clientInfo_array[i].infoObj.institution_id
          ) {
            this.form.clientInfo_array.splice(i, 1);
          } else {
            i++;
          }
        }
      } else {
        item.onoff = true;
        let obj = {};
        obj.checkinArray = [];
        obj.infoObj = {
          institution_id: item.institution_id,
          institution_name: item.institution_name,
          reference_obj: item.reference_obj,
          reference_id: item.reference_id,
          address: item.address,
          institution_grade: item.institution_grade,
          checkin_time: null,
          checkout_time: null,
          target_num: item.target_num,
          cover_num: item.cover_num,
        };
        this.form.clientInfo_array.push(obj);
      }
    },
    checkVisitInfoStore(item) {
      // console.log(this.form.clientInfo_array)
      if (item.onoff === true) {
        item.onoff = false;
        for (let i = 0; i < this.form.clientInfo_array.length; ) {
          if (
            item.store_id === this.form.clientInfo_array[i].infoObj.store_id
          ) {
            this.form.clientInfo_array.splice(i, 1);
          } else {
            i++;
          }
        }
      } else {
        // console.log(item)
        item.onoff = true;
        let obj = {};
        obj.checkinArray = [];
        obj.infoObj = {
          store_id: item.store_id,
          store_name: item.store_name,
          reference_obj: item.reference_obj,
          reference_id: item.reference_id,
          address: item.address,
          retailstore_grade: item.retailstore_grade,
          checkin_time: null,
          checkout_time: null,
          target_num: item.target_num,
          cover_num: item.cover_num,
        };
        this.form.clientInfo_array.push(obj);
      }
    },
    checkVisitInfoDis(item) {
      // console.log(item)
      if (item.onoff === true) {
        item.onoff = false;
        for (let i = 0; i < this.form.clientInfo_array.length; ) {
          if (
            item.distributor_id ===
            this.form.clientInfo_array[i].infoObj.distributor_id
          ) {
            this.form.clientInfo_array.splice(i, 1);
          } else {
            i++;
          }
        }
      } else {
        item.onoff = true;
        let obj = {};
        obj.checkinArray = [];
        obj.infoObj = {
          distributor_id: item.distributor_id,
          distributor_name: item.distributor_name,
          reference_obj: item.reference_obj,
          reference_id: item.reference_id,
          address: item.address,
          distributor_grade: item.distributor_grade,
          checkin_time: null,
          checkout_time: null,
          target_num: item.target_num,
          cover_num: item.cover_num,
        };

        this.form.clientInfo_array.push(obj);
      }
    },
    addAssessBool() {
      this.assessBool = true;
    },
    async getCoachingFromList() {
      try {
        let user = this.$store.getters.getUser;
        let data = {
          tenant_id: user.tenant_id,
        };
        await http
          .post("/wapi/Tutoring/getCoachingFromList", data)
          .then((res) => {
            if (res.success === true) {
              let array1 = res.data;
              if (array1.length > 0) {
                for (let k = 0; k < array1.length; k++) {
                  array1[k].final_score = 0;
                  for (let p = 0; p < array1[k].category_array.length; p++) {
                    array1[k].category_array[p].failed_items = 0;
                    array1[k].category_array[p].incompleted_items = 0;
                    array1[k].category_array[p].passed_items = 0;
                    array1[k].category_array[p].subtotal_score = 0;
                  }
                }
              }
              let array2 = this.form.formInfo_array;

              if (array2.length > 0) {
                for (let i = 0; i < array1.length; i++) {
                  for (let j = 0; j < array2.length; j++) {
                    array1[i].onoff = false;
                    if (array1[i].form_id === array2[j].form_id) {
                      array1[i].onoff = true;
                      break;
                    }
                  }
                }
              } else {
                for (let i = 0; i < array1.length; i++) {
                  array1[i].onoff = false;
                }
              }

              this.addCoachingFromList.coachingFromArray = array1;
              this.addCoachingFromList.smallFromArray = this.addCoachingFromList.coachingFromArray[0].category_array;

              this.copyAddCoachingFromList.coachingFromArray = JSON.parse(
                JSON.stringify(array1)
              );
              this.copyAddCoachingFromList.smallFromArray = JSON.parse(
                JSON.stringify(
                  this.addCoachingFromList.coachingFromArray[0].category_array
                )
              );
            }
          });
      } catch (e) {}
    },
    getClassProject(item) {
      this.addCoachingFromList.smallFromArray = item.category_array;
      if (item.onoff === true) {
        item.onoff = false;
        for (let i = 0; i < this.form.formInfo_array.length; ) {
          if (item.form_id === this.form.formInfo_array[i].form_id) {
            this.form.formInfo_array.splice(i, 1);
          } else {
            i++;
          }
        }
      } else {
        item.onoff = true;
        let obj = {};
        obj.from_name = item.title;
        obj.category_array = item.category_array;
        obj.form_id = item.form_id;
        obj.final_score = item.final_score;
        this.form.formInfo_array.push(obj);
      }
    },
    openSavePlanModel() {
      this.modelSavePlanPs = true;
    },
    async btnSubmitClick() {
      let loading = this.$loading({
        lock: true,
        text: "拼命加载中",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      try {
        let data = {
          tenant_id: this.$store.getters.getUser.tenant_id,
          status: "SUBMITTED",
          user_id: this.$store.getters.getUser.user_id,
          key_id: this.form.activity_id,
        };

        // if (!(this.form.start_date)){
        //     this.$message({
        //         type:'error',
        //         message: '请选择日期'
        //     })
        //     loading.close()
        //     return false;
        // }
        // if (!(this.form.end_date)){
        //     this.$message({
        //         type:'error',
        //         message: '请选择日期'
        //     })
        //     loading.close()
        //     return false;
        // }
        if (data.key_id) {
          if (this.form.confirmed_result === "DENIED") {
            let onoff = this.btnSaveClick();
            if (onoff === false) {
            } else {
              await http
                .post("/wapi/Tutoring/submitCoaching", data)
                .then((res) => {
                  if (res.success === true) {
                    // this.init()
                    // loading.close()
                    this.$message({
                      type: "success",
                      message: "提交成功",
                    });
                    this.$router.push({
                      name: "tutoring",
                    });
                  }
                });
            }
          } else {
            await http
              .post("/wapi/Tutoring/submitCoaching", data)
              .then((res) => {
                if (res.success === true) {
                  // this.init()
                  // loading.close()
                  this.$message({
                    type: "success",
                    message: "提交成功",
                  });
                  this.$router.push({
                    name: "tutoring",
                  });
                }
              });
          }
        } else {
          this.btnSaveClick("submit");
          // this.$message({
          //     type:'error',
          //     message:'请先保存协访'
          // })
          // loading.close()
        }
      } catch (e) {
        loading.close();
      }
    },
    async btnAgreeClick() {
      try {
        let data = {
          status: "APPROVED",
          user_id: this.$store.getters.getUser.user_id,
          key_id: this.form.activity_id,
          tenant_id: this.$store.getters.getUser.tenant_id,
        };
        await http.post("/wapi/Tutoring/submitCoaching", data).then((res) => {
          if (res.success === true) {
            this.$message({
              type: "success",
              message: "批准成功",
            });
            this.$router.push({
              name: "tutoring",
            });
            //this.init()
          }
        });
      } catch (e) {}
    },
    async btnRefuseClick() {
      try {
        let data = {
          status: "DENIED",
          user_id: this.$store.getters.getUser.user_id,
          key_id: this.form.activity_id,
          tenant_id: this.$store.getters.getUser.tenant_id,
        };
        await http.post("/wapi/Tutoring/submitCoaching", data).then((res) => {
          if (res.success === true) {
            this.$message({
              type: "success",
              message: "批准成功",
            });
            this.$router.push({
              name: "tutoring",
            });

            //this.init()
          }
        });
      } catch (e) {}
    },
    async savePlanPs() {
      let loading = this.$loading({
        lock: true,
        text: "拼命加载中",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      try {
        let data = {
          type: "FORM",
          tenant_id: this.$store.getters.getUser.tenant_id,
          id: this.form.activity_id,
          user_id: this.$store.getters.getUser.user_id,
          contents: {
            comments: this.contents,
            photos: [],
          },
        };
        await http.post("/wapi/Evection/savePlanPs", data).then((res) => {
          if (res.success === true) {
            this.init();
            this.$message({
              type: "success",
              message: "保存成功",
            });
            this.modelSavePlanPs = false;
            this.contents = "";
            // this.$router.push({
            //     name:'tutoring'
            // })
          }
        });
      } catch (e) {
        loading.close();
      }
    },
    inputBtnSaveClick() {
      this.$refs["formlist"].validate((valid) => {
        if (!valid) {
          return false;
        } else {
          this.btnSaveClick();
        }
      });
    },
    async btnSaveClick(type) {
      try {
        let loading = this.$loading({
          lock: true,
          text: "拼命加载中",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)",
        });
        let user = this.$store.getters.getUser;
        let data = this.form;
        data.tenant_id = user.tenant_id;
        data.user_id = user.user_id;

        data.start_time = moment(data.start_time).format("YYYY-MM-DD HH:mm");
        data.end_time = moment(data.end_time).format("YYYY-MM-DD HH:mm");
        data.activity_date = moment(data.start_time).format("YYYY-MM-DD");
        data.client = this.form.clientInfo_array;
        data.form = this.form.formInfo_array;
        if (user.alias.role === "staff") {
          data.initiator = "COACHEE";
        } else {
          data.initiator = "COACH";
        }

        if (data.start_time === "" || data.end_time === "") {
          this.$message({
            message: "请选择时间",
            type: "error",
          });
          loading.close();
          return false;
        }
        if (data.start_time === "") {
          this.$message({
            message: "请选择时间",
            type: "error",
          });
          loading.close();
          return false;
        }
        if (data.coach_id === "") {
          this.$message({
            message: "请选择协访人",
            type: "error",
          });
          loading.close();
          return false;
        }
        if (data.coaching_type === "") {
          this.$message({
            message: "请选择协访类型",
            type: "error",
          });
          loading.close();
          return false;
        }

        if (this.onoffRecord) {
          data.status = "ACTIVE";
        } else {
          data.status = "DRAFT";
        }

        await http.post("/wapi/Tutoring/savaCoachingInfo", data).then((res) => {
          console.log(res);
          if (res.success === true) {
            if (this.status === "NEW") {
              this.data = res.data[0];

              this.status = "INFO";
            }

            if (type === "submit") {
              let obj = {
                tenant_id: this.$store.getters.getUser.tenant_id,
                status: "SUBMITTED",
                user_id: this.$store.getters.getUser.user_id,
                key_id: this.data.activity_id,
              };

              http.post("/wapi/Tutoring/submitCoaching", obj).then((res) => {
                if (res.success === true) {
                  // this.init()
                  this.$message({
                    type: "success",
                    message: "提交成功",
                  });
                  this.$router.push({
                    name: "tutoring",
                  });
                  // loading.close()
                }
              });
            } else {
              //如果被拒绝就不显示保存按钮
              if (data.confirmed_result !== "DENIED") {
                this.$message({
                  type: "success",
                  message: "保存成功",
                });
              }
              this.$router.push({
                name: "tutoring",
              });
              // this.init()
              // loading.close()
            }
          } else {
            this.$message({
              type: "error",
              message: res.message,
            });
            loading.close();
          }
        });
      } catch (e) {
        loading.close();
      }
    },
    async btnDeleteClick() {
      this.$confirm("确认删除?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          try {
            let user = this.$store.getters.getUser;
            let data = this.form;
            data.tenant_id = user.tenant_id;
            data.user_id = user.user_id;
            await http.post("/wapi/Tutoring/delCoaching", data).then((res) => {
              if (res.success === true) {
                this.$message({
                  type: "success",
                  message: "删除成功",
                });
                this.$router.go(-1);
              }
            });
          } catch (e) {
            loading.close();
          }
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    upDataSheetTable(obj, type) {
      if (this.onoffForm) {
        if (type === "danger") {
          obj.passed = "PASSED";
        } else if (type === "deniedDanger") {
          obj.passed = "DENIED";
        }
      } else {
        return false;
      }
    },
    async upDataDteails() {
      try {
        let user = this.$store.getters.getUser;
        let data = {
          tenant_id: user.tenant_id,
          status: "SUBMITTED",
          key_id: this.detailsInfo.key_id,
        };
        await http
          .post("/wapi/Tutoring/submitCoachingForm", data)
          .then((res) => {
            this.$message({
              type: "success",
              message: "提交成功",
            });
            this.init();
            this.detailsBool = false;
          });
      } catch (e) {}
    },
    async upDataDetailsFrom() {
      let loading = this.$loading({
        lock: true,
        text: "拼命加载中",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      let passed_items = 0;
      let failed_items = 0;
      let incompleted_items = 0;
      let subtotal_score = 0;
      let final_score = 0;
      for (let i = 0; i < this.detailsInfo.category_array.length; i++) {
        for (
          let j = 0;
          j < this.detailsInfo.category_array[i].item_array.length;
          j++
        ) {
          let itemsObj = this.detailsInfo.category_array[i].item_array[j];
          switch (itemsObj.item_type) {
            case "TRUE-FALSE":
              if (itemsObj.passed === "PASSED") {
                passed_items += 1;
                subtotal_score += 10;
              } else if (itemsObj.passed === "DENIED") {
                failed_items += 1;
              } else {
                incompleted_items += 1;
              }
              break;
            case "SCORE":
              if (!(itemsObj.score == "0")) {
                subtotal_score += parseInt(itemsObj.score);
                if (
                  parseFloat(itemsObj.pass_score) <= parseFloat(itemsObj.score)
                ) {
                  passed_items += 1;
                } else {
                  failed_items += 1;
                }
              } else {
                incompleted_items += 1;
              }
              break;
              case "SCORE5":
                  if (!(itemsObj.score == "0")) {
                      subtotal_score += parseInt(itemsObj.score);
                      if (
                          parseFloat(itemsObj.pass_score) <= parseFloat(itemsObj.score)
                      ) {
                          passed_items += 1;
                      } else {
                          failed_items += 1;
                      }
                  } else {
                      incompleted_items += 1;
                  }
                  break;
            case "STAR":
              if (!(itemsObj.stars == "0")) {
                let stars = parseFloat(itemsObj.stars) * 2;
                itemsObj.stars_num = stars;
                subtotal_score += stars;
                if (
                  parseFloat(itemsObj.pass_score) <=
                  parseFloat(itemsObj.stars_num)
                ) {
                  passed_items += 1;
                } else {
                  failed_items += 1;
                }
              } else {
                incompleted_items += 1;
              }
              break;
          }
        }

        this.detailsInfo.category_array[i].passed_items = passed_items;
        this.detailsInfo.category_array[i].failed_items = failed_items;
        this.detailsInfo.category_array[
          i
        ].incompleted_items = incompleted_items;
        this.detailsInfo.category_array[i].subtotal_score = subtotal_score;
        final_score += subtotal_score;
        passed_items = 0;
        failed_items = 0;
        incompleted_items = 0;
        subtotal_score = 0;
      }

      try {
        let user = this.$store.getters.getUser;
        let data = this.detailsInfo;
        data.tenant_id = user.tenant_id;
        this.detailsInfo.final_score = final_score;

        await http
          .post("/wapi/Tutoring/saveCoachingFormInfo", data)
          .then((res) => {
            this.$message({
              type: "success",
              message: "提交成功",
            });
            final_score = 0;
            this.init();
            this.detailsBool = false;
            loading.close();
          });
      } catch (e) {
        loading.close();
      }
    },
    startchange(obj, item) {},
    reMoveClient(item, i) {
      console.log(this.form);
      this.form.clientInfo_array.splice(i, 1);

      if (item.infoObj.reference_obj === "INSTITUTION") {
        for (let j = 0; j < this.addVisitForm.institutionsArray.length; j++) {
          if (
            item.infoObj.institution_id ===
            this.addVisitForm.institutionsArray[j].institution_id
          ) {
            this.addVisitForm.institutionsArray[j].onoff = false;
          }
        }
      } else if (item.infoObj.reference_obj === "RETAILSTORE") {
        for (let j = 0; j < this.addVisitForm.retailstoreArray.length; j++) {
          if (
            item.infoObj.store_id ===
            this.addVisitForm.retailstoreArray[j].store_id
          ) {
            this.addVisitForm.retailstoreArray[j].onoff = false;
          }
        }
      } else if (item.infoObj.reference_obj === "DISTRIBUTOR") {
        for (let j = 0; j < this.addVisitForm.distributorArray.length; j++) {
          if (
            item.infoObj.distributor_id ===
            this.addVisitForm.distributorArray[j].distributor_id
          ) {
            this.addVisitForm.distributorArray[j].onoff = false;
          }
        }
      }
    },
    clickCoa() {
      if (this.form.territory_id == "") {
        this.$message({
          type: "warning",
          message: "请先选择辖区",
        });
      }
    },
    changeCoachee() {
      this.form.formInfo_array = [];
      this.form.form_array = [];
      this.form.clientInfo_array = [];
      this.form.client_array = [];
    },
    async btnSuccess() {
      let dateTimeNow = moment(new Date()).valueOf();
      let timeStamp = moment(this.form.activity_date).valueOf();
      if (dateTimeNow < timeStamp) {
        this.$message({
          type: "error",
          message: "协访日期未到,不能完成协访",
        });
        return false;
      }

      try {
        let loading = this.$loading({
          lock: true,
          text: "拼命加载中",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)",
        });

        let user = this.$store.getters.getUser;
        let data = this.form;
        data.tenant_id = user.tenant_id;
        data.user_id = user.user_id;

        data.start_time = moment(data.start_time).format("YYYY-MM-DD HH:mm");
        data.end_time = moment(data.end_time).format("YYYY-MM-DD HH:mm");
        data.activity_date = moment(data.start_time).format("YYYY-MM-DD");
        data.client = this.form.clientInfo_array;
        data.form = this.form.formInfo_array;
        if (user.alias.role === "staff") {
          data.initiator = "COACHEE";
        } else {
          data.initiator = "COACH";
        }

        // if(data.start_time === '' || data.end_time === ''){
        //     this.$message({
        //         message: '请选择时间',
        //         type: 'warning'
        //     })
        //     loading.close()
        //     return false;
        // }
        // if(data.start_time === ''){
        //     this.$message({
        //         message: '请选择时间',
        //         type: 'warning'
        //     })
        //     loading.close()
        //     return false;
        // }
        // if(data.coach_id === ''){
        //     this.$message({
        //         message: '请选择协访人',
        //         type: 'warning'
        //     })
        //     loading.close()
        //     return false;
        // }
        // if (data.formInfo_array.length === 0){
        //     this.$message({
        //         message: '评估表不能为空',
        //         type: 'warning'
        //     })
        //     loading.close()
        //     return false;
        // }else {
        //     let onoff = true
        //     for (let i=0;i<data.formInfo_array.length;i++){
        //         if (data.formInfo_array[i].submitted_date === ''){
        //             onoff = false
        //             break
        //         }
        //     }
        //     if (onoff === false){
        //         loading.close()
        //         return false;
        //     }
        // }
        data.completed = "T";
        await http.post("/wapi/Tutoring/savaCoachingInfo", data).then((res) => {
          if (res.success === true) {
            this.$message({
              type: "success",
              message: "保存成功",
            });
            this.$router.push({
              name: "tutoring",
            });
            // this.init()
            // loading.close()
          }
        });
      } catch (e) {
        loading.close();
      }
    },
    // 获取图片id
    async getImgUrl(obj) {
      try {
        let data = {
          reference_obj: "INSTITUTION",
          reference_id: "com.saasyun.android",
          credential: "0a4da4e6-e36a-4e78-b4fc-78bb62aa9ff4",
          photo_ids: obj.photo_id,
          tenant_id: this.$store.getters.getUser.tenant_id,
        };

        let res = await http.post("/photos/downloadphotos", data);
        let array = res.data;

        if (array.length > 0) {
          obj.src = array[0].thu_url;
          this.$forceUpdate();
        }
      } catch (err) {
        console.log(`error:${err}`);
      }
    },
    addAssist() {
      if (this.form.coachee_id) {
        this.assistBool = true;
        if (this.clientObj.showInstitution) {
          this.activeName = "医疗机构";
        } else if (
          !this.clientObj.showInstitution &&
          this.clientObj.showStore
        ) {
          this.activeName = "零售终端";
        } else if (
          !this.clientObj.showInstitution &&
          !this.clientObj.showStore &&
          this.clientObj.showDistributor
        ) {
          this.activeName = "分销客户";
        }
      } else {
        this.$message({
          type: "warning",
          message: "请先选择被协访人",
        });
      }
    },
    async getTerritoryList() {
      let data = {
        tenant_id: this.$store.getters.getUser.tenant_id,
        user_id: this.$store.getters.getUser.user_id,
      };
      await http.post("/wapi/Tutoring/getTerritoryList", data).then((res) => {
        if (res.success) {
          this.optionTerritoryList = res.data;
        } else {
          Message.error(res.message);
        }
      });
    },
  },
};
</script>

<style scoped>
/*#container {*/
/*    background: #fff;*/
/*    padding: 0px 50px;*/
/*    height: 100%;*/
/*    box-sizing: border-box;*/
/*}*/
#association >>> .el-form-item__label {
  font-size: 16px;
  color: #000000;
  padding-left: 0px;
  text-align: left;
  padding-right: 40px;
}
#association {
  height: 100%;
}
#association #assist >>> .el-form-item__label {
  font-size: 16px;
  color: #000000;
  padding-left: 0px;
  text-align: left;
  padding-right: 40px;
}
#association >>> .el-table_1_column_7 {
  color: #3b99f7;
}
#association >>> .el-table th {
  padding: 7px 0px;
}
#association >>> .el-table td {
  padding: 7px 0px;
}
#association #assist >>> .el-tabs__nav-scroll {
  position: relative;
  height: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
}
#association #assist >>> .el-tabs__nav {
  display: block;
  /*position: absolute;*/
  border: 1px solid transparent;
  /*left: 50%;*/
  /*margin-left: -150px;*/
}
#association #assist >>> .el-tabs__header {
  border-bottom: none;
}
#association #assist >>> .el-tabs__item {
  border: 1px solid #dcdfe6;
  padding-left: 20px;
  padding-right: 20px;
}
#association #assist >>> .is-active {
  color: #409eff;
  border: 1px solid #c6e2ff;
  background-color: #ecf5ff;
}
#association #assist >>> .el-tabs__item:first-child {
  border-radius: 4px 0 0 4px;
}
#association #assist >>> .el-tabs__item:nth-of-type(2) {
  border-left: none;
  border-right: none;
}
#association #assist >>> .el-tabs__item:last-child {
  border-radius: 0px 4px 4px 0px;
  border-right: 1px solid #dcdfe6;
}
#association >>> .el-tag.el-tag--info {
  background: #ff9901;
  color: #ffffff;
  border: none;
}
#association >>> .el-tag.el-tag--info .el-tag__close {
  display: none;
}
#association >>> .el-rate__icon {
  font-size: 23px;
}
#association #input >>> .el-input {
  border: 1px solid #ff9901;
  border-radius: 5px;
  font-size: 18px;
  color: #ff9901;
}
#association #input >>> .el-input__inner {
  color: #ff9901 !important;
  border: none;
}
#association #input >>> .el-input__suffix {
  background: #ff9901;
  color: #fff;
  right: 0;
}
#association .scoreActive {
  border: 1px solid #3b99f7 !important;
  background: #3b99f7;
  color: #ffffff !important;
}
#association >>> .el-icon-edit-outline:before {
  margin-right: 5px;
}
#association >>> .el-icon-time:before {
  margin-right: 5px;
}
#association >>> .el-icon-edit-outline:before {
  font-size: 16px;
}
#association >>> .el-icon-edit-outline span {
  position: relative;
  top: -2px;
  font-size: 13px;
}
#association >>> .el-dialog__body {
  padding: 20px 20px 30px;
}
</style>
<style>
#association .el-dialog__header {
  padding: 0;
}
#association #travelSavePlanPs .el-textarea__inner {
  height: 400px;
}
</style>




// WEBPACK FOOTER //
// src/pages/calendar/components/assist.vue